import { render } from "./previewImagePop.vue?vue&type=template&id=4a28faaa"
import script from "./previewImagePop.vue?vue&type=script&lang=js"
export * from "./previewImagePop.vue?vue&type=script&lang=js"

import "./previewImagePop.vue?vue&type=style&index=0&id=4a28faaa&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/previewImagePop.vue'],['render',render],['__file',"previewImagePop.vue"]])

export default __exports__